import { useState, useEffect } from 'react';
import { uploadQueueService } from '@/services/UploadQueueService';
import logger from '@/lib/logger';

/**
 * Hook to monitor network status and trigger upload queue retries
 */
export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      uploadQueueService.retryAll();
      logger.info('[NetworkStatus] Connection restored. Retrying uploads...');
      // TODO: Add toast info notification: Connection restored. Retrying uploads...
    };

    const handleOffline = () => {
      setIsOnline(false);
      logger.warn('[NetworkStatus] Connection lost. Measurements will be queued.');
      // TODO: Add toast warning notification: Connection lost. Measurements will be queued.
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}